import React from "react";
import {
  Box,
  Button,
  Container,
  Link,
  TextField,
  Typography,
  InputAdornment,
  IconButton,
  Alert,
} from "@mui/material";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import background from "../../assets/img/header/img-2.png";
import logo from "../../assets/img/logo.jpg";
import { useAuth } from "../../context/AuthContext";

import { Link as RouterLink, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE } from "../../config/api";
import emailjs from "emailjs-com";

export default function Login() {
  const [showPassword, setShowPassword] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState("");
  const [loading, setLoading] = React.useState(false);
 const { fetchMe } = useAuth();
  const navigate = useNavigate();
  const { login } = useAuth();

const handleBack = () => navigate(-1);


  const handleLogin = async () => {
    setError("");

    try {
      const res = await axios.post(`${API_BASE}/login`, {
        email,
        password,
      });
   // =============================
    // ENVÍO DE CORREO AL CLIENTE
    // =============================
    if (email) {
      try {
        await emailjs.send(
          "service_zsccg3j",
          "template_2fof6nr",
          { name: res.data.name, email: res.data.email},
          "9016C6iHqY8pBLbs1"
        );
      } catch (emailError) {
        console.error('Error enviando el correo al cliente:', emailError);
        // Aquí podrías decidir notificar al usuario o reintentar
      }
    } else {
      console.warn('No se proporcionó correo del usuario, no se envió el email.');
    }
      // Guarda token + usuario en el contexto
      login(res.data.token, res.data.user);

      // Redirige al home
      navigate("/");
    } catch (err) {
      console.error(err);
      setError("Email o contraseña incorrectos");
    }
  };
const handleLoginSuccess = async (response) => {
  setLoading(true);

  try {
    // Validación inicial de la credencial de Google
    if (!response?.credential) {
      throw new Error('No se recibió la credencial de Google.');
    }

    // Enviar token al backend para autenticación
    const { data } = await axios.post(
      `${API_BASE}/auth/google`,
      { token: response.credential },
      { headers: { 'Content-Type': 'application/json' } }
    );

    // Validación de la respuesta del backend
    const { token, userId, role, name, email } = data;
    if (!token || !userId || !role) {
      throw new Error('La respuesta de autenticación es inválida.');
    }

    // Guardar información del usuario en localStorage
    localStorage.setItem('token', token);
    localStorage.setItem('userId', userId);
    localStorage.setItem('role', role);

    // Actualizar estado global de autenticación
    login(token);

    // =============================
    // ENVÍO DE CORREO AL CLIENTE
    // =============================
    if (email) {
      try {
        await emailjs.send(
          "service_zsccg3j",
          "template_2fof6nr",
          { name, email },
          "9016C6iHqY8pBLbs1"
        );
      } catch (emailError) {
        console.error('Error enviando el correo al cliente:', emailError);
        // Aquí podrías decidir notificar al usuario o reintentar
      }
    } else {
      console.warn('No se proporcionó correo del usuario, no se envió el email.');
    }

    // Obtener información adicional del usuario
    fetchMe(token);

    // Redirigir al inicio evitando que vuelva al login
    navigate('/', { replace: true });

  } catch (error) {
    console.error('Error en autenticación con Google OAuth:', error);
    // Aquí puedes mostrar un toast o modal con mensaje amigable al usuario
  } finally {
    setLoading(false);
  }
};

  return (
      <GoogleOAuthProvider clientId="612012951762-nj766julnqv94n6dpfl862ro0ufh1mou.apps.googleusercontent.com">


    <Box
      sx={{
        display: "flex",
        height: "100vh",
        bgcolor: "#fff",
      }}
    >

      {/* Botón volver */}
      <IconButton
        sx={{
          position: "absolute",
          top: 16,
          left: 16,
          color: "#000",
        }}
        onClick={handleBack}
      >
        <ArrowBackIcon />
      </IconButton>

      {/* LEFT SIDE */}
      <Container
        maxWidth="sm"
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          p: 4,
        }}
      >
        {/* LOGO */}
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <img
            src={logo}
            alt="Logo"
            style={{ height: 150, borderRadius: "100%" }}
          />
        </Box>

        <Typography
          variant="h4"
          fontWeight={600}
          mb={1}
          sx={{ mt: 4, textAlign: "center" }}
        >
          Ingresar
        </Typography>

    
   
<GoogleLogin
  onSuccess={handleLoginSuccess}
  onError={() => {
    setError('Error al iniciar sesión con Google');
  }}
  width="100%"
  useOneTap={false}
/>
        {/* Separador "o" */}
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Box sx={{ flex: 1, height: "1px", bgcolor: "#ccc" }} />
          <Typography sx={{ mx: 2, color: "#999", fontSize: 14 }}>o</Typography>
          <Box sx={{ flex: 1, height: "1px", bgcolor: "#ccc" }} />
        </Box>

        {/* ERROR */}
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {/* EMAIL */}
        <TextField
           size="small"
          fullWidth
          label="Correo electrónico"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{ mb: 2 }}
        />

        {/* PASSWORD */}
        <TextField
          fullWidth
           size="small"
          label="Contraseña"
          type={showPassword ? "text" : "password"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          sx={{ mb: 2 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <Link
          component={RouterLink}
          to="/olvide-mi-contrasena"
          underline="hover"
          sx={{ fontSize: 14, mb: 3, alignSelf: "flex-start" }}
        >
          ¿Olvidaste tu contraseña?
        </Link>

        {/* LOGIN BUTTON */}
        <Button
          variant="contained"
          fullWidth
          onClick={handleLogin}
          disabled={loading}
          sx={{
            bgcolor: "#000",
            height: 45,
            borderRadius: 1.5,
            fontWeight: 600,
            "&:hover": { bgcolor: "#000" },
          }}
        >
          Ingresar
        </Button>

        <Typography color="text.secondary" mt={2} sx={{ textAlign: "center" }}>
          ¿No tienes una cuenta?{" "}
          <Link href="/registrar" underline="hover">
            Crear cuenta
          </Link>
        </Typography>
      </Container>

      {/* RIGHT PANEL */}
      <Box
        sx={{
          width: "50%",
          display: { xs: "none", md: "flex" },
          justifyContent: "center",
          alignItems: "center",
          backgroundImage: `url(${background})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
    </Box>
      </GoogleOAuthProvider>

  );
}
